import IconSpeedometer from './IconSpeedometer.vue';
import IconEnergy from './IconEnergy.vue';
import IconBadge from './IconBadge.vue';
import IconWrench from './IconWrench.vue';
import IconPuzzle from './IconPuzzle.vue';
import IconFire from './IconFire.vue';
import IconLayers from './IconLayers.vue';
import IconPicture from './IconPicture.vue';
import IconShop from './IconShop.vue';
import IconMegaphone from './IconMegaphone.vue';

export {
        IconSpeedometer,
        IconEnergy,
        IconBadge,
        IconWrench,
        IconPuzzle,
        IconFire,
        IconLayers,
        IconPicture,
        IconShop,
        IconMegaphone,
};

export const iconMap = {
        'si si-speedometer': IconSpeedometer,
        'si si-energy': IconEnergy,
        'si si-badge': IconBadge,
        'si si-wrench': IconWrench,
        'si si-puzzle': IconPuzzle,
        'si si-fire': IconFire,
        'si si-layers': IconLayers,
        'si si-picture': IconPicture,
        'si si-shop': IconShop,
        'si si-megaphone': IconMegaphone,
};
